<template>
    <div class="form-group" v-if="noWrapper">
        <textarea
                slot="input" class="form-control ignoreValidation"
                ref='input'
                @input="updateValue($event.target.value)"
                @blur="$emit('blur', $event.target.value)"
                @keyup.enter="$emit('enter', $event.target.value)"
                :value="modelValue"
                :placeholder="$attrs.placeholder ? $attrs.placeholder : label"
                @change="handleChange"
                :maxlength="maxlength"
                :rows="rows"
                :required="isRequired"
                v-bind="$attrs"
        > </textarea>
    </div>
    <np-responsive v-else>
        <template #label>
        <span>{{label}}</span>
        <span
            v-if="!!helpText"
            data-placement="right"
            data-container="body"
            data-bs-toggle="popover"
            :title="label"
            :data-popover-content="helpText"
            class="helpBtn addPopover helpHeader">
            <i tabindex="-1" class="fa fa-info-circle"></i>
        </span>
        </template>
        <template #input>
        <div class="form-group ">
            <textarea class="form-control"
                      ref='input'
                      @input="updateValue($event.target.value)"
                      @blur="$emit('blur', $event.target.value)"
                      @keyup.enter="$emit('enter', $event.target.value)"
                      @change="handleChange"
                      :value="modelValue"
                      :placeholder="$attrs.placeholder ? $attrs.placeholder : label"
                      :maxlength="maxlength"
                      :rows="rows"
                      :required="isRequired"
                      v-bind="$attrs"
            > </textarea>
            <a class="input-group-addon" style="cursor: pointer" v-if="hasAddon() && !addonOnLeft"
               @click="$emit('addon-click', modelValue)">
                <slot name="addon"></slot>
            </a>
        </div>
        </template>
    </np-responsive>
</template>

<script>

    import NPResponsive from './np-responsive.vue';

    export default {
        name: 'np-textarea',
        props: {
            label: String,
            value: {},
            modelValue: {},
            noWrapper: Boolean,
            required: {
                default: true,
            },
            addonOnLeft: {
                default: false
            },
            maxlength: {
                default: 50,
            },
            rows: {
                default: 3,
            },
            rules: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            helpText: {
                type: String,
                default :'',
            },
        },
        data: function () {
            return {
                default_readonly: false,
                page_config_required: false
            }
        },
        computed: {
            inputRef: function () {
                return this.$refs.input;
            },
            isRequired: function () {
                let paths = String(window.location.pathname).split('/');
                let controller =  paths.length > 1 ? paths[1] : '';
                let action =  paths.length > 2 ? paths[2] : '';
                return controller === 'application' && action !== 'filter' ? !!this.page_config_required : !!this.required;
            }
        },
        mounted: function () {
            //note:  jQuery validation require elements wrapped in <form></form>
            $(this.inputRef).on('change keyup', function () {
                $(this).valid();
            })
            this.rules.forEach(rule => {
                this.inputRef.setAttribute(`data-rule-${rule}`, '');
            })
        },
        methods: {
            hasAddon: function () {
                return !!this.$slots.addon;
            },
            handleChange: function (event) {
                if (this.$attrs.type === 'file') {
                    const files = event.target.files;  //return FileList object
                    this.$emit('files', files);
                }
            },
            removeErrorClass: function () {
                let parent = $(this.inputRef).parent();
                parent.removeClass("has-error");
                parent.removeClass("focused-in");
                $(this.inputRef).tooltip('destroy');
                $(this.inputRef).tooltip('hide');
            },
            updateValue(value){
                this.$emit('update:modelValue', value);
                this.$emit('input', value);
            }
        },
        watch: {
            modelValue: function (value) {
                $(this.inputRef)
                    .val(value)
                    .trigger('change');
                this.updateValue(value)
            },
            required: function (required) {
                if (required === false) {
                    this.removeErrorClass();
                }
            },
        },
        components: {
            'np-responsive': NPResponsive
        }
    };
</script>
